import Head from "next/head";
import type { ReactNode } from "react";

import { Toaster } from "@sorcery/ui";

import { Footer } from "./Footer";
import { HeaderDecorator } from "./HeaderDecorator";
import { ModalDecorator } from "./ModalDecorator";

const DEFAULT_TITLE = "Curiosa";
const DEFAULT_DESCRIPTION = "A Sorcery: Contested Realm deck building app.";
const DEFAULT_IMAGE = "https://i.imgur.com/BLlNqQm.png";

type PageProps = {
  children: ReactNode;
  title?: string;
  description?: string;
  image?: string;
  hero?: ReactNode;
};

export const Page = ({
  children,
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  hero,
}: PageProps) => (
  <>
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="og:image" content={image} />
      <link rel="icon" href="/favicon.ico" />
    </Head>
    {/* content */}
    <section className="z-0">{hero}</section>
    <main className="relative z-10">
      <HeaderDecorator />
      <div className="flex min-h-[calc(100vh-4rem)] flex-col justify-between animate-in fade-in">
        <div className="container mx-auto p-8 duration-700 animate-in fade-in">{children}</div>
        <Footer />
      </div>
    </main>
    <Toaster position="bottom-left" closeButton />
    <ModalDecorator />
  </>
);
